import useAuth from 'common/useAuth';
import { LoadingIndicator, PasswordForm } from 'components';
import { PublicPage } from 'components/Layout';
import type { PasswordFormValues } from 'components/PasswordForm/PasswordForm';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import type { PasswordToCreate } from './models';

type RouteParams = 'token' | 'userId';

const PasswordPage: React.FC = (): React.ReactElement => {
  const { t } = useCustomTranslation();

  const params = useParams<RouteParams>();
  const { login, loading } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (values: PasswordFormValues) => {
    const { token, userId } = params;

    const submitValues: PasswordToCreate = {
      newPassword: values.newPassword,
      token: token || '',
      userId: userId || ''
    };

    void submitValues;
    const result: any = await Promise.resolve(); // TODO: replace with correct endpoint when registration support returned
    await login({
      username: result.data.username,
      password: values.newPassword,
      customTenantCode: result.data.tenantCode
    });
    navigate('/');
  };

  const renderPasswordForm = () => {
    return (
      <>
        <div className="PasswordPage_content-heading heading">
          {t('company.createNewPasswordHeading')}
        </div>
        <PasswordForm onSubmit={handleSubmit} />
      </>
    );
  };

  const renderLoginAnimation = () => {
    return (
      <>
        <div className="PasswordPage_content-heading heading">
          {t('company.loginFromPasswordHeading')}
        </div>
        <LoadingIndicator />
      </>
    );
  };

  return (
    <PublicPage className="PasswordPage" title={t('company.createNewPasswordHeading')}>
      <div className="PasswordPage_content white-box">
        {loading ? renderLoginAnimation() : renderPasswordForm()}
      </div>
    </PublicPage>
  );
};

export default PasswordPage;
